// REACT
import React, { Component } from "react";
import MosaicsTable from "./MosaicsTable.jsx";
import "./RemoteSensing.scss";

class RemoteSensing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDataLoaded: false,
      windowHeight: window.innerHeight
    };
  }

  componentDidMount() {    
    window.addEventListener('resize', this.handleResizeDPZ);
  
    // Volanie funkcie pre aktualizáciu výšky elementu
    this.updateElementHeight();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResizeDPZ);
  }

  updateElementHeight = () => {
    const targetElement = document.getElementById('rs-container');
    if (targetElement) {
      const newHeight = this.state.windowHeight - 113;
      targetElement.style.height = `${newHeight}px`;
    }
  };

  handleResizeDPZ = () => {
    this.setState({
      windowHeight: window.innerHeight,
    }, () => {
      this.updateElementHeight(); // Zavolajte aktualizáciu výšky cieľového elementu po nastavení stavu
    });
  };


  handleResize = () => {
    this.setState({
      windowHeight: window.innerHeight,
    }, () => {
      this.updateElementHeight(); // Zavolajte aktualizáciu výšky cieľového elementu po nastavení stavu
    });
  };


  render() {
    return (
      <>
        {/* <div className="tool-header">
          <img className="dpz-icon" src={images["satellite-32x32.png"]} alt="dpz icon" />
          <div className="tool-header-text">DPZ modul</div>
        </div> */}
        <div id="rs-container">
          <div className="ui centered grid">
            <div className="sixteen wide column">
              {this.state.isDataLoaded ? (
                <MosaicsTable />
              ) : (
                <div className="loadImagery-btn">
                  <button
                    className="ui button btn-primary"
                    // id="btnLoadMosaics"
                    onClick={() => this.setState({ isDataLoaded: true })}
                  >
                    Načítať snímky...
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default RemoteSensing;

// IMPORT ALL IMAGES
const images = importAllImages(
  require.context("./../../images/", false, /\.(png|jpe?g|svg)$/)
);
function importAllImages(r) {
  let images = {};
  r.keys().map((item, index) => (images[item.replace("./", "")] = r(item)));
  return images;
}
